module.exports = __webpack_public_path__ + "img/icon_tongzhi@2x.e17ca90b.png";